import request from '@/utils/request'

/**
 * 菜单管理 API
 * 全部使用 POST 方法，路径前缀 /api/admin/menu
 */

// 获取全量菜单树
export function getMenuTree() {
  return request({
    url: '/api/admin/menu/tree',
    method: 'post'
  })
}

// 获取指定角色的已授权菜单 ID 数组
export function getRoleMenus(params) {
  return request({
    url: '/api/admin/menu/role-menus',
    method: 'post',
    data: params // { role }
  })
}

// 保存角色授权菜单（覆盖式）
export function saveRoleMenus(data) {
  return request({
    url: '/api/admin/menu/save-role-menus',
    method: 'post',
    data // { role, menuIds: [...] }
  })
}

// 获取当前用户可见菜单树
export function getUserMenus() {
  return request({
    url: '/api/admin/menu/user-menus',
    method: 'post'
  })
}

// 创建菜单
export function createMenu(data) {
  return request({
    url: '/api/admin/menu/create',
    method: 'post',
    data // { parentId, title, label, path, icon, perm, sort, visible }
  })
}

// 更新菜单
export function updateMenu(data) {
  return request({
    url: '/api/admin/menu/update',
    method: 'post',
    data // 含 id
  })
}

// 删除菜单
export function deleteMenu(data) {
  return request({
    url: '/api/admin/menu/delete',
    method: 'post',
    data // { id }
  })
}

// 调整菜单排序 (up/down)
export function moveMenu(data) {
  return request({
    url: '/api/admin/menu/move',
    method: 'post',
    data // { id, direction }
  })
}
